import React, { useEffect, useState } from 'react';
import useDragTranslate from '../hooks/useDragTranslate';
import { getRandomWindowPosition } from '../utils/windowPositioning';

const EnvironmentsWindow = ({ onClose, zIndex, onFocus }) => {
  const { elRef, onPointerDown, onPointerMove, onPointerUp } = useDragTranslate(onFocus);
  
  // Generate random position for this window
  const [windowPosition] = useState(() => getRandomWindowPosition(600, 500));
  
  const handleFocus = () => {
    onFocus && onFocus();
    /* bring window to front when clicked */
  };

  const handleClose = () => {
    // 1) Add .closing
    elRef.current?.classList.add('closing');

    // 2) After animation end, call onClose to unmount
    const done = () => {
      elRef.current?.removeEventListener('animationend', done);
      onClose();
    };
    elRef.current?.addEventListener('animationend', done, { once: true });
  };

  useEffect(() => {
    // listen on the document so we can move outside the window bounds
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    return () => {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
    };
  }, [onPointerMove, onPointerUp]);
  // Generate array of 46 images
  const images = Array.from({ length: 46 }, (_, i) => `assets/3d${i + 1}.png`);

  return (
    <div
      ref={elRef}
      className="window"
      data-window="environments"
      style={{
        display: 'block',
        width: '90vh',
        height: '70vh',
        zIndex: zIndex,
        overflow: 'auto',
        position: 'fixed',
        '--tx': `${windowPosition.tx}px`,
        '--ty': `${windowPosition.ty}px`,
        // IMPORTANT: do NOT set left/top/transform here; CSS handles it.
      }}
      onClick={handleFocus}
    >
      <div className="title-bar draggable" onPointerDown={onPointerDown}>
        <div className="title-bar-text">3D Environments - Viewer.exe</div>
        <div className="title-bar-controls">
          <button aria-label="Close" onClick={handleClose}></button>
        </div>
      </div>
      <div className="window-body">
        <h3>3D Game Environments</h3>
        <p>Explore my portfolio of custom-built scenes created & optimized in Autodesk 3DS Max then integrated into live game environments. *all screenshots are in-engine on live services*</p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {images.map((image, index) => (
            <img 
              key={index}
              src={image} 
              alt={`Environment ${index + 1}`} 
              style={{ width: '96%', imageRendering: 'auto' }} 
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnvironmentsWindow;
